/** Approximate printed page size for buyer-facing copy (billing uses raw characters). */
export const CHARS_PER_PAGE = 1800;

export function approxPages(characters: number): number {
  return Math.max(1, Math.round(characters / CHARS_PER_PAGE));
}

export function pageEstimateTooltip(characters: number): string {
  return `Estimated from ${characters.toLocaleString()} characters of parsed document text (~${CHARS_PER_PAGE.toLocaleString()} characters per page). Not the same as your PDF page count.`;
}

export function formatAnalysedPagesLine(characters: number, documentCount?: number | null): string {
  const pages = approxPages(characters);
  const pagePart = `About ${pages.toLocaleString()} page${pages === 1 ? "" : "s"} of document text analysed`;
  if (documentCount != null && documentCount > 0) {
    return `${pagePart} across ${documentCount.toLocaleString()} document${documentCount === 1 ? "" : "s"}`;
  }
  return pagePart;
}
